import { LaunchMetricType } from '~/api/metrics';

export const useLaunchMetricTypeLabelMap = () =>
  computed<Record<LaunchMetricType, string>>(() => {
    const { t } = useI18n();

    return {
      [LaunchMetricType.COMPLETED]: t('content.completed'),
      [LaunchMetricType.OPENED]: t('content.opened'),
      [LaunchMetricType.NOT_STARTED]: t('content.not-started'),
    };
  });

export const USE_LUNCH_METRICS_OPTIONS = () =>
  computed(() => {
    const LaunchMetricTypeLabelMap = useLaunchMetricTypeLabelMap();

    return Object.values(LaunchMetricType).map((type) => ({
      key: type,
      label: LaunchMetricTypeLabelMap.value[type],
    }));
  });
